import type { OverlappingReservation } from 'restaurantAdmin/reservations/concierge/apiHelpers';
import { MultiTableReservationFormData } from 'restaurantAdmin/reservations/concierge/MultiTableBookingForm';
import { Button, ButtonVariants } from '@components/button/Button';
import { Icon } from '@components/icon/Icon';
import { Modal } from '@components/modal/Modal';
import { ModalActions } from '@components/modal/ModalActions';
import { ISOTimeTo12HourTime } from '@utils/time';
import typography from '~styles/typography.scss';
import styles from './GodModeOverbookingWarningModal.scss';
import modalListStyles from './ModalListStyles.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (formData: MultiTableReservationFormData) => void;
  formData: MultiTableReservationFormData;
  overlappingReservations: OverlappingReservation[];
};

export const GodModeOverbookingWarningModal = ({
  isOpen,
  onClose,
  onConfirm,
  formData,
  overlappingReservations,
}: Props) => (
  <Modal isOpen={isOpen} onClose={onClose} title="You are about to overbook">
    <div className={styles.content}>
      <p className={styles.message}>
        Creating this reservation will result in overbooking. Are you sure you
        wish to proceed?
      </p>
      {overlappingReservations.length > 0 && (
        <div className={styles.reservationsList}>
          <div className={modalListStyles.listContainer}>
            <p className={modalListStyles.listLabel}>Affected reservations</p>
            <ul className={modalListStyles.list}>
              {overlappingReservations.map((reservation) => (
                <li key={reservation.id} className={modalListStyles.listItem}>
                  <p className={modalListStyles.listItemDetails}>
                    {reservation.guestFirstName} {reservation.guestLastName},{' '}
                    <span className={typography.t2}>
                      {ISOTimeTo12HourTime(reservation.reservationTime)}
                    </span>
                  </p>
                  <span className={styles.icons}>
                    {reservation.isVIP && (
                      <Icon
                        ariaLabel="VIP"
                        name="crown"
                        role="img"
                        fill="var(--gold)"
                      />
                    )}
                    {reservation.isPurchased && (
                      <Icon
                        ariaLabel="Purchased reservation"
                        name="dollar"
                        role="img"
                      />
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
    <ModalActions>
      <Button
        label="Cancel"
        onClick={onClose}
        variant={ButtonVariants.Tertiary}
      />
      <Button
        label="Confirm"
        onClick={() => {
          onClose();
          onConfirm(formData);
        }}
        variant={ButtonVariants.Tertiary}
      />
    </ModalActions>
  </Modal>
);
